import { Box, Flex, Image, Switch, Text, useToast } from "@chakra-ui/react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { GET_INSTANCE } from "../../../../apis/constants.api";
import { getInstance, updateVMInstance } from "../../../../apis/channel.api";
import { useEffect, useState } from "react";

const type = "vmInstance";

export default function VMInstance() {
  const queryClient = useQueryClient();

  const toast = useToast();

  const { data: instance } = useQuery({
    queryKey: [GET_INSTANCE],
    queryFn: getInstance,
  });

  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    const current = instance?.data.data.appConfig[0].isEnabled;
    if (typeof current === "boolean") {
      setIsEnabled(current);
    }
  }, [instance]);

  const { mutate: updateInstance } = useMutation({
    mutationFn: (data) => {
      return updateVMInstance(data);
    },
    onSuccess: (data) => {
      console.log("vm toggle", data);
      queryClient.invalidateQueries({ queryKey: [GET_INSTANCE] });

      toast({
        title: data?.data.message || "VM Instance updated successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    },
    onError: (data) => {
      toast({
        title: "Error",
        description: data?.response?.data?.message || "Something went wrong",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top-right",
      });
    },
  });

  const toggleVMAccess = async () => {
    const newState = !isEnabled;
    setIsEnabled(newState); // Optimistic update
    updateInstance({ type, isEnabled: newState });
  };

  return (
    <Box
      background={"#E6F4E6"}
      borderRadius="md"
      padding="14px"
      height={"auto"}
      width={"100%"}
    >
      <Box marginBottom="4">
        <Text fontWeight="bold" fontSize="xl">
          VMInstance
        </Text>
        <Text fontSize="sm" color="gray.600">
          Toggle to activate or deactivate VMInstance.
        </Text>
      </Box>

      <Flex direction="column" gap={4}>
        <Flex
          justify="space-between"
          align="center"
          background="white"
          padding="10px"
          borderRadius="md"
        >
          <Flex align="center" gap={4}>
            <Image
              src={"/assets/icons/instance.png"}
              alt={"vm instance"}
              boxSize="40px"
              objectFit="contain"
              borderRadius="full"
              background="#eee"
            />
            <Box>
              <Text fontWeight="bold">VM Instance</Text>
              <Text fontSize="sm" color="gray.500">
                Enable Instance Request
              </Text>
            </Box>
          </Flex>
          <Switch
            size="lg"
            isChecked={isEnabled}
            onChange={toggleVMAccess}
          />
        </Flex>
      </Flex>
    </Box>
  );
}
